import React from 'react';
import { Icon } from '@iconify/react';
import { Typography, Fab as MuiFab } from '@mui/material';

export const Fab = (props: {
    onClick: Function;
    mdiIcon: string | boolean;
    text: string;
}): React.JSX.Element => {
    const { onClick, mdiIcon, text } = props;

    const handleOnClick = (): void => {
        onClick();
    };

    return (
        <MuiFab
            variant='extended'
            onClick={handleOnClick}
            style={{
                height: '40px',
                background: '#FFFFFF',
                boxShadow:
                    '0px 3px 5px -1px rgba(0, 0, 0, 0.2), 0px 6px 10px rgba(0, 0, 0, 0.14), 0px 1px 18px rgba(0, 0, 0, 0.12)',
                borderRadius: '64px',
            }}
        >
            {mdiIcon ? (
                <>
                    <Icon
                        fontSize={'18px'}
                        style={{
                            color: '#3FB3B0',
                            marginRight: '6px',
                            height: 'auto',
                        }}
                        icon={`mdi:${mdiIcon}`}
                    />
                </>
            ) : (
                <></>
            )}
            <Typography
                sx={{
                    fontFamily: 'Red Hat Text',
                    fontWeight: 700,
                    fontSize: '14px',
                    lineHeight: '24px',
                    letterSpacing: '0.5px',
                    textTransform: 'uppercase',
                    color: '#285C6C',
                }}
            >
                {text}
            </Typography>
        </MuiFab>
    );
};
